module.exports = __webpack_public_path__ + "static/media/404-notfound.fc31c5cb.svg";